// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatsItemBlock {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    align-items: center;
}

.chatsItem {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
}

.chatsItemDataLine {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
}

.chatsItemCover {
    width: 60px;
    height: 60px;
    border-radius: 8px;
    object-fit: cover;
}

.chatsItemName {
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    color: #4B2D10;
}

.chatsItemButton {
    border: none;
    background: none;
    text-decoration: underline;
    font-family: Alegreya Sans;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    text-align: left;
    color: #8E3B00;
}

.chatsItemHr {
    border: none;
    border-top: 1px solid #BB8D6C;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Chats/ChatsItem/ChatsItem.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,WAAW;AACf","sourcesContent":[".chatsItemBlock {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    align-items: center;\n}\n\n.chatsItem {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.chatsItemDataLine {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: center;\n}\n\n.chatsItemCover {\n    width: 60px;\n    height: 60px;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n.chatsItemName {\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 24px;\n    text-align: left;\n    color: #4B2D10;\n}\n\n.chatsItemButton {\n    border: none;\n    background: none;\n    text-decoration: underline;\n    font-family: Alegreya Sans;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 19.2px;\n    text-align: left;\n    color: #8E3B00;\n}\n\n.chatsItemHr {\n    border: none;\n    border-top: 1px solid #BB8D6C;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
